/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { TOTPRegisterChallengeOptions } from './TOTPRegisterChallengeOptions';
import {
    TOTPRegisterChallengeOptionsFromJSON,
    TOTPRegisterChallengeOptionsFromJSONTyped,
    TOTPRegisterChallengeOptionsToJSON,
} from './TOTPRegisterChallengeOptions';

/**
 * 
 * @export
 * @interface TOTPRegisterChallengeAllOf
 */
export interface TOTPRegisterChallengeAllOf {
    /**
     * 
     * @type {TOTPRegisterChallengeOptions}
     * @memberof TOTPRegisterChallengeAllOf
     */
    options?: TOTPRegisterChallengeOptions;
}

/**
 * Check if a given object implements the TOTPRegisterChallengeAllOf interface.
 */
export function instanceOfTOTPRegisterChallengeAllOf(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function TOTPRegisterChallengeAllOfFromJSON(json: any): TOTPRegisterChallengeAllOf {
    return TOTPRegisterChallengeAllOfFromJSONTyped(json, false);
}

export function TOTPRegisterChallengeAllOfFromJSONTyped(json: any, ignoreDiscriminator: boolean): TOTPRegisterChallengeAllOf {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'options': !exists(json, 'options') ? undefined : TOTPRegisterChallengeOptionsFromJSON(json['options']),
    };
}

export function TOTPRegisterChallengeAllOfToJSON(value?: TOTPRegisterChallengeAllOf | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'options': TOTPRegisterChallengeOptionsToJSON(value.options),
    };
}

